import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Gate for authenticated routes.
 *
 * `requireAdmin` additionally checks the role. Note this is a *convenience*
 * guard only — it hides UI, it does not secure data. Every admin endpoint on
 * the API enforces the role server-side as well, which is what actually
 * matters.
 */
export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="container section"
        role="status"
        aria-live="polite"
        style={{ minHeight: '50vh' }}
      >
        <p className="type-body-lg">Checking your sign-in…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Remember where they were headed so login can send them back.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/account" replace />;
  }

  return children;
}
